module.exports = __webpack_public_path__ + "static/img/logo-white.8ee59c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos/logo-white.png
// module id = RMjB
// module chunks = 0